export default function (props: any) {
  return (
    <svg
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M14.6673 14H1.33398V15.3333H14.6673V14Z" fill="white" />
      <path
        d="M10.8946 0.666504L2.66797 8.89316V12.6665H6.44131L14.668 4.43985L10.8946 0.666504ZM5.88797 11.3332H4.00131V9.4465L10.8946 2.55316L12.7813 4.43982L5.88797 11.3332Z"
        fill="white"
      />
    </svg>
  );
}
